import React from 'react'
import { Alert } from './Alert'
import { GoogleSignInButton } from './GoogleSignInButton'
import { MicrosoftSignInButton } from './MicrosoftSignInButton'

/**
 * Single Sign-On section (Microsoft + Google).
 *
 * Owns each provider's sign-in error so it can surface in the page's top-level
 * alert block — matching the styling of the structural error states rendered
 * above it — rather than inline under the button.
 */
export function SsoSection() {
  const [microsoftError, setMicrosoftError] = React.useState<string | null>(null)
  const [googleError, setGoogleError] = React.useState<string | null>(null)

  return (
    <>
      {microsoftError && (
        <Alert variant="error" id="alert-microsoft-signin" title="Microsoft Sign-In">
          {microsoftError}
        </Alert>
      )}

      {googleError && (
        <Alert variant="error" id="alert-google-signin" title="Google Sign-In">
          {googleError}
        </Alert>
      )}

      <section className="flex flex-col gap-3" aria-label="SSO Sign In Options">
        {/* Microsoft sign-in (MSAL) — wired to POST /auth/microsoft */}
        <MicrosoftSignInButton onError={setMicrosoftError} />

        {/* Google sign-in (GIS) — wired to POST /auth/google */}
        <GoogleSignInButton onError={setGoogleError} />
      </section>
    </>
  )
}
